module.exports = __webpack_public_path__ + "img/nt1-00-75-1_1.prt.f1cf3799.jpg";